module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-ad80eaf5.png";